import { Component, Injector, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { User } from 'src/app/model/user';
import { BaseComponent } from '../common/BaseComponent';
import { UserService } from 'src/app/service/UserService';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Admin } from 'src/app/model/admin';
import { PasswordValidator } from 'src/app/validator/PasswordValidator';
import { Constants } from 'src/app/util/Constants';
import { CommonService } from 'src/app/service/CommonService';

@Component({
  selector: 'app-req-authorize',
  templateUrl: './req-authorize.component.html',
  styles: [
  ]
})
export class ReqAuthorizeComponent extends BaseComponent implements OnInit {
  reqAzForm: FormGroup;
  submitted: boolean = false;
  restSub: Subscription;
  user: User;
  admin: Admin;
  appErrorPrefix: string = "bss.reqAuthorize.error";
  errorCode = "";
  resourceUrl: string = "";
    
  constructor(
    injector: Injector,
    public rest: UserService) {
    super(injector);
    //this.pageMsgRendered = false;
  }

  ngOnInit(): void {

    this.reqAzForm = new FormGroup({     
      adminemail: new FormControl(null, Validators.compose([Validators.required, PasswordValidator.invalidEmail])),
      confirmadminemail: new FormControl(null, Validators.compose([Validators.required]))      
    },
      {
        validators: [compareEmailValidator('adminemail', 'confirmadminemail')]
      });

    this.resourceUrl = sessionStorage.getItem("resource_url");
    if (!this.resourceUrl || this.resourceUrl === "null" || this.resourceUrl.trim().length === 0) {
      this.route.queryParams.subscribe(params => {
        const fullResourceUrl = (params['resource_url'])?.trim() ?? '';
        this.resourceUrl = CommonService.determineSigninUrl(fullResourceUrl);
        sessionStorage.setItem("resource_url", this.resourceUrl);
      });
    }

    console.log("resource_url going to be submitted: [" + this.resourceUrl + "]");
  }

  // on Submit()
  onSubmit(): void {    
    this.submitted = true;
    //this.pageMsgRendered = false;
    
    console.log('In Submit() reqAzForm.valid:  ' + this.reqAzForm.valid);

    if (this.reqAzForm.valid) {
      this.isSubmitting = true;
      const sessionUser = sessionStorage.getItem("user");
      this.user = JSON.parse(sessionUser);

      // Update below code - 
      this.admin = this.reqAzForm.value;
      this.admin.resource_url = this.resourceUrl;
      console.log("roleReqAuthz:: User values to be posted: " + JSON.stringify(this.admin));

      // Call  roleReqAuthz- which invokes backend API - rolereqauthz
      this.restSub = this.rest.roleReqAuthz(this.admin).subscribe(response => {
      console.log("roleReqAuthz:" + JSON.stringify(response));
      if (response.result > 0) {
        this.appError = true;
        this.appErrorMessage = this.getMessage(this.appErrorPrefix + "." + response.error_code);
        this.router.navigate(['public/invalidrequest']);
      }
      else
        this.router.navigate(['secure/reqauthorized/success']);
    });      
    }
  }

  onCancel(): void {
    this.router.navigate(['secure/profile']);
  }  

}

function compareEmailValidator(source: string, target: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any; } | null => {
    const sourceCtrl = control.get(source);
    const targetCtrl = control.get(target);
    return sourceCtrl && targetCtrl && sourceCtrl.value !== targetCtrl.value ? { mismatchEmail: true } : null;
  };
}
